'use client';

import { useCallback, useState } from 'react';
import { useUserGeolocation } from '.';

export const useUserFormattedAddress = () => {
    const { getCurrentPosition } = useUserGeolocation();
    const [userFormattedAddress, setUserFormattedAddress] = useState<string>();

    return useCallback(
        (callback: (formattedAddress: string) => void) => {
            if (userFormattedAddress) {
                callback(userFormattedAddress);
            } else {
                getCurrentPosition((formattedAddress) => {
                    setUserFormattedAddress(formattedAddress);
                    callback(formattedAddress);
                });
            }
        },
        [getCurrentPosition, setUserFormattedAddress, userFormattedAddress],
    );
};
